import {OutlineEyeIcon, OutlineEyeOffIcon} from '@tempmee/react-icons'
import {type InputHTMLAttributes, forwardRef, useState} from 'react'
import {InputTextField} from '../input-text-field/InputTextField'

export interface InputPasswordFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> {
  /** Applies error styling (red border + background) */
  isError?: boolean
}

export const InputPasswordField = forwardRef<HTMLInputElement, InputPasswordFieldProps>(
  (props, ref) => {
    const [isVisible, setIsVisible] = useState(false)

    const toggleButton = (
      <button
        type="button"
        onClick={() => setIsVisible((v) => !v)}
        // Figma paints the reveal toggle `primary/main`, not the field's text
        // colour — it is an affordance rather than content. Overrides the
        // `text-text-secondary` the adornment wrapper sets; the wrapper sizes
        // the glyph via `[&_svg]:size-6`.
        className="cursor-pointer pointer-events-auto text-primary"
        aria-label={isVisible ? 'Hide password' : 'Show password'}
      >
        {isVisible ? <OutlineEyeOffIcon /> : <OutlineEyeIcon />}
      </button>
    )

    return (
      <InputTextField
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        rightIcon={toggleButton}
        {...props}
      />
    )
  },
)

InputPasswordField.displayName = 'InputPasswordField'
